import { useEffect, useState } from "react";
import { BotMessageSquare, Loader2, MessagesSquare, Sparkles, UserRound } from "lucide-react";
import { api } from "../../lib/api";

// Statistiques du robot Messenger (demande du propriétaire, 2026-10-08) :
// combien de questions le robot a répondu SEUL avec l'IA (7 derniers jours et
// total), et combien ont filé directement au propriétaire sans réponse du robot.
export default function MessengerBotStats() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get("/admin/messenger/stats")
      .then((r) => { if (alive) setD(r.data); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, []);

  return (
    <div data-testid="messenger-bot-stats" className="mt-10 border-t border-ivory/10 pt-8">
      <p className="font-semibold flex items-center gap-2 mb-1">
        <BotMessageSquare className="w-4 h-4 text-gold" /> Robot Messenger — statistiques
      </p>
      <p className="text-xs text-ivory/70 mb-6">
        Ce que le robot d'accueil Facebook Messenger a répondu seul (7 derniers jours et depuis le début).
      </p>
      {err ? (
        <p className="text-sm text-red-300" data-testid="messenger-stats-error">Statistiques indisponibles — réessayez.</p>
      ) : !d ? (
        <p className="text-sm text-ivory/50" data-testid="messenger-stats-loading">
          <Loader2 className="w-4 h-4 animate-spin inline mr-2" />Chargement…
        </p>
      ) : d.conversations_total === 0 ? (
        <p className="text-sm text-ivory/50" data-testid="messenger-stats-empty">
          Aucune conversation Messenger pour l'instant — le robot accueillera les clients qui écrivent à la page Facebook.
        </p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            [MessagesSquare, "Conversations (7 j)", d.conversations_7j, "text-gold", "convos-7j"],
            [Sparkles, "Réponses du robot (7 j)", d.reponses_ia_7j, "text-emerald-300", "ia-7j"],
            [UserRound, "Filées au propriétaire (7 j)", d.sans_reponse_ia_7j, "text-champagne", "sans-ia-7j"],
            [BotMessageSquare, "Réponses du robot (total)", d.reponses_ia_total, "text-ivory", "ia-total"],
          ].map(([Icon, lab, val, cls, tid]) => (
            <div key={tid} className="bg-surface border border-ivory/10 rounded-xl px-4 py-3">
              <p className="text-[10px] uppercase tracking-widest text-ivory/50 flex items-center gap-1.5">
                <Icon className="w-3 h-3" /> {lab}
              </p>
              <p className={`font-serif text-2xl mt-1 ${cls}`} data-testid={`messenger-stat-${tid}`}>{val}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
